export default __webpack_public_path__ + "static/media/typicalweek (6).a1068876.png";